import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { InvoiceCheckType } from '@/types/invoiceVaultTypes';
import { RecipientProfileRowType, RecipientRequestVerificationType } from '@/types/vendorVaultTypes';

export type InvoiceCheckActionType = 'revoke' | 'resend' | 'archive';

export const invoiceCheckActionApi = (
  id: string,
  action: InvoiceCheckActionType
): Promise<ApiResponseType<InvoiceCheckType>> => {
  return authApiService.POST(`/invoice-vault/checks/${id}/${action}/`, {});
};

export const unmaskInvoiceCheckApi = (
  id: string
): Promise<ApiResponseType<{ rows: RecipientProfileRowType[]; record_hash: string; blockchain_id: string }>> => {
  return authApiService.GET(`/invoice-vault/checks/${id}/unmask/`);
};

export const getInvoiceCheckVerificationApi = (
  id: string
): Promise<ApiResponseType<RecipientRequestVerificationType>> => {
  return authApiService.GET(`/invoice-vault/checks/${id}/verification/`);
};
